"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeamMember: function() {
        return TeamMember;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const TeamMember = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.99994 4C5.44766 4 4.99994 4.44772 4.99994 5C4.99994 5.55228 5.44766 6 5.99994 6C6.55223 6 6.99994 5.55228 6.99994 5C6.99994 4.44772 6.55223 4 5.99994 4ZM2.99994 5C2.99994 3.34315 4.34309 2 5.99994 2C7.6568 2 8.99994 3.34315 8.99994 5C8.99994 6.65685 7.6568 8 5.99994 8C4.34309 8 2.99994 6.65685 2.99994 5ZM17.9999 4C17.4477 4 16.9999 4.44772 16.9999 5C16.9999 5.55228 17.4477 6 17.9999 6C18.5522 6 18.9999 5.55228 18.9999 5C18.9999 4.44772 18.5522 4 17.9999 4ZM14.9999 5C14.9999 3.34315 16.3431 2 17.9999 2C19.6568 2 20.9999 3.34315 20.9999 5C20.9999 6.65685 19.6568 8 17.9999 8C16.3431 8 14.9999 6.65685 14.9999 5ZM11.9999 10C10.8953 10 9.99988 10.8954 9.99988 12C9.99988 13.1046 10.8953 14 11.9999 14C13.1045 14 13.9999 13.1046 13.9999 12C13.9999 10.8954 13.1045 10 11.9999 10ZM7.99988 12C7.99988 9.79086 9.79074 8 11.9999 8C14.209 8 15.9999 9.79086 15.9999 12C15.9999 14.2091 14.209 16 11.9999 16C9.79074 16 7.99988 14.2091 7.99988 12ZM1.20045 11.3988C2.29343 9.94409 4.03658 9 5.99994 9C6.55223 9 6.99994 9.44772 6.99994 10C6.99994 10.5523 6.55223 11 5.99994 11C4.69211 11 3.53091 11.6266 2.79944 12.6002C2.46769 13.0417 1.84082 13.1307 1.39927 12.799C0.957719 12.4673 0.868705 11.8404 1.20045 11.3988ZM16.9999 10C16.9999 9.44772 17.4477 9 17.9999 9C19.9636 9 21.7069 9.94434 22.7999 11.3994C23.1316 11.841 23.0425 12.4679 22.6009 12.7996C22.1593 13.1313 21.5324 13.0422 21.2007 12.6006C20.4693 11.6268 19.3079 11 17.9999 11C17.4477 11 16.9999 10.5523 16.9999 10ZM5.4336 20.4279C6.87755 18.3578 9.27969 17 11.9991 17C14.7185 17 17.1206 18.3578 18.5646 20.4279C18.8806 20.8809 18.7695 21.5042 18.3165 21.8202C17.8635 22.1361 17.2402 22.0251 16.9242 21.5721C15.8383 20.0152 14.0372 19 11.9991 19C9.96103 19 8.15992 20.0152 7.07398 21.5721C6.75801 22.0251 6.13467 22.1361 5.68169 21.8202C5.22872 21.5042 5.11764 20.8809 5.4336 20.4279Z",
        fill: "currentColor"
    })
}), "TeamMember");
const _default = TeamMember;
